import config from 'SRC/config/config.json'

export const adPriceTypes = config.adForm.addAdForm.adPriceTypes
